<template>
  <div
    class="dashboard-stat"
    :class="[`dashboard-stat--${tone}`, { 'dashboard-stat--compact': compact }]"
  >
    <div class="dashboard-stat__header">
      <div class="dashboard-stat__icon" v-if="icon">
        <v-icon size="18" color="inherit">{{ icon }}</v-icon>
      </div>
      <div class="dashboard-stat__copy">
        <span class="dashboard-stat__label">{{ title1 }}</span>
        <span v-if="subtitle" class="dashboard-stat__subtitle">{{ subtitle }}</span>
      </div>
    </div>
    <strong class="dashboard-stat__value">{{ title2 }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: String,
    title1: String,
    title2: String,
    subtitle: String,
    icon: String,
    tone: {
      type: String,
      default: "neutral",
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.dashboard-stat {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
  min-height: 132px;
  padding: 18px 20px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.dashboard-stat--compact {
  min-height: 112px;
  padding: 16px 18px;
}

.dashboard-stat:hover {
  box-shadow: var(--shadow-md);
}

.dashboard-stat__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.dashboard-stat__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  flex-shrink: 0;
}

.dashboard-stat__copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.dashboard-stat__label {
  color: var(--color-text-muted);
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.4;
}

.dashboard-stat__subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  line-height: 1.35;
}

.dashboard-stat__value {
  color: var(--color-text);
  font-size: clamp(1.35rem, 2vw, 1.85rem);
  font-weight: 700;
  line-height: 1.1;
}

.dashboard-stat--primary .dashboard-stat__icon {
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.dashboard-stat--success .dashboard-stat__icon {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.dashboard-stat--warning .dashboard-stat__icon {
  background: rgba(217, 119, 6, 0.12);
  color: #d97706;
}

.dashboard-stat--danger .dashboard-stat__icon {
  background: rgba(225, 29, 72, 0.1);
  color: #e11d48;
}

.dashboard-stat--neutral .dashboard-stat__icon {
  background: rgba(100, 116, 139, 0.12);
  color: #64748b;
}

.dashboard-stat--highlight {
  min-height: 148px;
  border-color: rgba(22, 163, 74, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #f8fffb 100%);
}

.dashboard-stat--highlight .dashboard-stat__icon {
  background: rgba(22, 163, 74, 0.12);
  color: #16a34a;
}

.dashboard-stat--highlight .dashboard-stat__value {
  font-size: clamp(1.6rem, 2.4vw, 2.1rem);
}
</style>
